// extracted by mini-css-extract-plugin
export default {"expressContainer":"ExpressView_expressContainer__2n7iT"};